import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-raci2',
  templateUrl: './raci2.component.html',
  styleUrls: ['./raci2.component.scss']
})
export class Raci2Component implements OnInit {
  @ViewChild('cper',null) cper;
  @ViewChild('craci',null) craci;
  @ViewChild('cpro',null) cpro;
  @ViewChild('cprol',null) cprol;
  @ViewChild('cpa',null) cpa;
  @ViewChild('cdep',null) cdep;
  @ViewChild('chtd',null) chtd;
  @ViewChild('cht',null) cht; 
  constructor(
    public authService: AuthService,
    private sanitizer: DomSanitizer,
    public router: Router) { 
    }
    razonsocial="";
    procesos=[{id:0,proceso:"",descripcion:"",idx:0,valor:0,valor_:"",raci2:0}];
    area=[{id:0, area:"",idx:0,id_ant:0}];
    rel_pa=[{id:0,id_p:0,id_a:0,rol:"",c:"",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""} ];
id_raci:Number=0
  ngOnInit() {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.ls_raci();
    this.get_org();    
    this.sel_raci();
  }
  cliente;
  gda_htd(){
    let postData = {
      id_hoja_trabajo:this.id_ht,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    console.log("gda_htd");
    console.log(postData);
    this.authService.service("/api/ins_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  dupl_ht(itm){
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/dupl_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_ht();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  fmt_ht(){
  
    localStorage.setItem("t_ht","X");
    localStorage.setItem("id_ht",this.id_ht.toString());
    this.router.navigate([]).then(result => {  window.open('./#/fmtht', '_blank'); });     
  }
  fmt_ht_pdf(){
    
    localStorage.setItem("t_ht","P");
    localStorage.setItem("id_ht",this.id_ht.toString());
    this.router.navigate([]).then(result => {  window.open('./#/fmtht', '_blank'); });     
  }
  edt_htd(itm){
    ///console.log(itm);
    this.htdet.id=itm.id;
    this.htdet.simbolo1=itm.simbolo1;
    this.htdet.simbolo2=itm.simbolo2;
    this.htdet.simbolo3=itm.simbolo3;
    this.htdet.simbolo4=itm.simbolo4;
    this.htdet.tipo=itm.tipo;
    this.htdet.principal=itm.principal;
    this.htdet.importante=itm.importante;
    this.htdet.razon=itm.razon;
    this.htdet.tiempo=itm.tiempo;
    this.htdet.im1=itm.im1;
    this.htdet.im2=itm.im2;
    this.htdet.im3=itm.im3;
    this.htdet.im4=itm.im4;
    this.htdet.url=itm.url;
    this.htdet.role=itm.role;
    this.bndSavehtd=false;
  }
  htdet={
    id:0,
    num:0,
    tipo:"",
    simbolo1:0,
    simbolo2:0,
    simbolo3:0,
    simbolo4:0,
    principal:"",
    importante:"",
    razon:"",
    tiempo:0,
    role:0,
    im1:"",im2:"",im3:"",im4:"",url:""
  };
  usuario;
  togle_ht_list(){
    this.bnd_htl=false;
    if(this.bnd_list_ht==true){
      this.bnd_list_ht=false
    }else{
      this.bnd_list_ht=true;
      this.bnd_ht=false;
    }
  }
   
  gda_ht(){
    let postData = {
      nombre:this.ht_name,
      fecha:this.fecha_ht,
      codigo:this.codigo_ht,
      usuario:this.usuario,
      a:this.a_,
      p:this.p_
    } 
      console.log(postData);
      this.authService.service("/api/ins_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            if(this.bnd_htp){this.ls_htp();}
            else{this.ls_ht();}
            this.msg_ht="";
            //this.bnd_list_ht=true;
            //console.log(data)
            this.cht.nativeElement.click();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  upd_img(){
    //this.uploadFileToActivity();   
    this.ls_ht_det();
  }
  upd_htd(){
    let postData = {
      id:this.htdet.id,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    //console.log(postData);
    this.authService.service("/api/upd_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
   upd_ht(){
    let postData = {
      id:this.id_ht,
      nombre:this.ht_name,
      fecha:this.fecha_ht,
      codigo:this.codigo_ht,
      usuario:this.usuario,
      a:this.a_,
      p:this.p_
    } 
      //console.log(postData);
      this.authService.service("/api/upd_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.ls_ht(); 
            this.cht.nativeElement.click();
            //this.ht_list=res;
            //console.log(data)
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          }); 
  }
  n_ht(){
    this.usuario=Number(localStorage.getItem("usuario"));
    this.ht_name="";
    this.bndSaveht=true;
    this.fecha_ht="";
    this.codigo_ht="";
    //this.ls_ht();
    this.loading=false;
    this.bnd_list_ht=true;
  }
  nvo_htd(){    
    //this.htd=[];
    this.htdet.simbolo1=0,
    this.htdet.simbolo2=0,
    this.htdet.simbolo3=0,
    this.htdet.simbolo4=0,
    this.htdet.tipo="H";
    this.htdet.principal="";
    this.htdet.importante="";
    this.htdet.razon="";
    this.htdet.tiempo=0;
    this.htdet.im1="";
    this.htdet.im2="";
    this.htdet.im3="";
    this.htdet.im4="";
    this.htdet.url="";
    this.htdet.role=0;
    //this.bnd_list_ht=true
    this.bndSavehtd=true;
  }
  del_htd(itm){
    if(confirm("Desea eliminar el registro")==false)return;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });    
  }
  ls_cliente(){
    let postData = {
      id:Number(localStorage.getItem("id_cliente"))
    } 
    this.authService.service("/api/get_cliente_by_id",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.cliente=data;
          console.log(data)
          this.razonsocial=data[0].razonsocial;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  sel_raci(){
    this.raci_list=[];
    try {
      for(var i=0;i<this.raci.length;i++){
      if(this.org_id==this.raci[i].id_org)
      this.raci_list.push(this.raci[i]);
    }
    } catch (error) {      
    }
    
  }
  org;
  org_;
  org_id=-1;
  org_id2=-1;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            this.org_=this.authService.org_head(this.org);
            //console.log(this.org_);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  
  btn_dep:boolean=true;
  btn_pro:boolean=true;
  id_pro:Number=0;
  id_dep:Number=0;
  upd_proceso_lado(itm){
     console.log(itm);
    this.id_pro=itm.id;
    this.pro_="";
    this.des_="";
    this.val_="";
  }
  upd_proceso(itm){  
    this.vdel_pro=true; 
    this.btn_pro=false; 
    //console.log(itm);
    this.id_pro=itm.id;
    this.pro_=itm.proceso;
    this.des_=itm.descripcion;
    this.val_=itm.valor;
  }

  vdel_area:boolean=true;
  vdel_dep_(){
    this.vdel_area=false;
  }
  can_dep(){
    this.vdel_area=true;
  }

  _area2(itm){
    this.id_dep=itm.id;
    this.dep_="";
  }
  upd_area(itm){    
    this.vdel_area=true;
    this.btn_dep=false;
    //console.log(itm);
    this.id_dep=itm.id;
    this.dep_=itm.area;
  }
  bnd_list:Boolean=true;
  
  togle_raci_list(){
    if(this.bnd_list==true){
      this.bnd_list=false
    }else{
      this.bnd_list=true;
    }
  }
  async dupl_raci(itm){
    if(confirm("Confirm to copy this RACSI?")==false)return;
    let postData = {
      id_raci:itm.id
    }
    this.procesos=[];
    //console.log(postData);
    await this.authService.service("/api/copy_raci",postData)
    .then(
      async data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        //this.update_raci();
        console.log(this.raci);
        console.log(this.raci_list);
        this.ls_raci()
        this.cper.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  upd_dep(){
    let postData = {
      dep:this.dep_,
      id:this.id_dep
    }
    this.procesos=[];
    this.authService.service("/api/upd_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        this.update_raci();
        this.cdep.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  vdel_pro:boolean=true;
  can_pro(){
    this.vdel_pro=true;
  }
  vdel_pro_(){
    this.vdel_pro=false;
  }
  del_dep(){
    let postData = {
      id:this.id_dep
    }
    this.procesos=[];
    this.authService.service("/api/del_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        this.update_raci();
        this.cdep.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  public loading;
  mov_idx(itm,t){
    this.loading=true;
    let postData = {      
      lado:t,     
      id:itm.id
    }
    this.procesos=[];
    //console.log(postData);
    this.authService.service("/api/mov_idx_pro",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        //swal.fire('¡ok!', '', 'success');
        this.update_raci();
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta! mov_idx', '', 'error');
          this.loading=false;
      });    
  }
  mov_idx_dep(itm,t){
    this.loading=true;
    let postData = {      
      lado:t,     
      id:itm.id
    }
    this.procesos=[];
    //console.log(postData);
    this.authService.service("/api/mov_idx_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        //swal.fire('¡ok!', '', 'success');
        this.update_raci();
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta! mov_idx', '', 'error');
          this.loading=false;
      });    
  }
  upd_pro(){
    let postData = {      
      proceso:this.pro_,
      descripcion:this.des_,
      valor:"",
      id:this.id_pro,
      raci:this.raciaux_
    }
    //this.procesos=[];
    //console.log(postData);
    this.t_memo="upd";
    this.ap_memo="pro";
    this.authService.service("/api/upd_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        this.cpro.nativeElement.click();
        this.memoria();
        //this.update_raci();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  delete_idx_procesos(){
    var procesos_aux=[];
    for(var i=0;i<this.procesos.length;i++){
      if(this.procesos[i].id!=this.id_pro){
        procesos_aux.push(this.procesos[i]);
      }
    }
    this.procesos=procesos_aux;

  }
  del_pro(){
    let postData = {      
      id:this.id_pro
    }
    
    this.t_memo="del";
    this.ap_memo="pro";
      //this.procesos=[];
    
      this.authService.service("/api/del_proceso",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                      
          this.memoria()
          this.cpro.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        }); 
    }
  raci_name;
  btn_racsi:boolean=false;
  v_raci(itm){
    this.loading=true;
    this.bnd_list=false;
    this.btn_racsi=true;
    this.id_raci=itm.id;
    this.raci_name=itm.descipcion
    this.update_raci();    
    this.loading=false;
  }
  update_raci(){
    this.ls_area();    
  }
  pa2_(p,a){
    var bnd=false;   
    //console.log(p+"::"+a);
    for(let p_a=0;p_a<this.rel_pa.length;p_a++){
      if(this.rel_pa[p_a].id_a==a && this.rel_pa[p_a].id_p==p){
        bnd=true;
      }
    }
    return bnd;
  }
  n_process(){
    this.des_="";
    this.val_="";
    this.vdel_pro=true;
    this.btn_pro=true;
    this.pro_="";
  }
  n_area(){
    this.vdel_area=true;
    this.btn_dep=true;
    this.dep_="";
  }
  raci:any;
  raci_list;
  async ls_raci(){
    this.rel_pa=[];
    let postData = {
    id_cliente:Number(this.id_cliente)}
    console.log(postData);
    this.authService.service("/api/get_raci",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        //console.log(res);
        this.raci=res;
        this.raci_list=[];
        try {
          for(var i=0;i<this.raci.length;i++){
          if(this.org_id==this.raci[i].id_org)
            this.raci_list.push(this.raci[i]);
          }
        } catch (error) {      
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
          this.loading=false;
      });  
      this.loading=false;

  }
  fmt_raci_(t,itm){
    localStorage.setItem("t_raci",t);
    localStorage.setItem("id_raci_pdf",itm.id);
    this.router.navigate([]).then(result => {  window.open('./#/fmt2', '_blank'); });            
  }
  fmt_raci(t){
    localStorage.setItem("t_raci",t);
    localStorage.setItem("id_raci_pdf",this.id_raci.toString());
    this.router.navigate([]).then(result => {  window.open('./#/fmt2', '_blank'); });          
  }
ls_pa(){
  this.rel_pa=[];
  let postData = {
    id_raci:this.id_raci
  }
  this.authService.service("/api/get_pa_2",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);             
      for(var i=0;i<res.length;i++){
        //console.log(res[i]);         
        this.rel_pa.push(
            {id:res[i].id,
            id_p:res[i].id_tarea,
            id_a:res[i].id_area,
            rol:res[i].rol,
            entregable:res[i].entregable,
            impacto:res[i].impacto,
            ttime:res[i].ttime,
            tipo_time:res[i].tipo_time,
            c:"X",
            valor:res[i].valor});
      }
      //console.log(res); 
      //this.load_rasci(); 
      //console.log(this.rel_pa);        
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  

}
raci_:any;
raci_id=0;
bndv_raci:boolean=true;

edt_raci(itm){
  this.bndv_raci=false;
  this.raci_id=itm.id;
  this.org_id2=this.org_id;
  //console.log(itm);
  this.raci_=itm.descipcion;
}
n_raci(){
  this.bndv_raci=true;
  this.raci_="";
}
upd_raci(){
  let postData = {
    id:this.raci_id,
    raci:this.raci_,
    org_id:this.org_id2
  }
  this.authService.service("/api/upd_raci",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);     
      this.ls_raci();
      this.craci.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
gda_raci(){
  let postData = {
    id_cliente:this.id_cliente,
    raci:this.raci_,
    org_id:this.org_id2
  }
  this.authService.service("/api/gda_raci",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);     
      this.ls_raci();
      this.craci.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
ls_proceso(){
  let postData = {
    id_raci:this.id_raci
  }
  this.procesos=[];
this.authService.service("/api/get_proceso",postData)
.then(
  data => {
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  
    console.log(data);                    
    for(var i=0;i<res.length;i++){

      this.procesos.push( { valor_:res[i].valor_,valor:res[i].valor,
        id:res[i].id, 
        proceso:res[i].Titulo,
        descripcion:res[i].Descripcion,
        idx:res[i].idx,
        raci2:Number(res[i].id_raci2)}
      );
    }
    this.ls_pa();
  },
  error => {
      var de= JSON.stringify(error);
      var di = JSON.parse(de)
      swal.fire('¡Información incorrecta!', '', 'error');
  });  
}
ls_area(){
  let postData = {
    id_raci:this.id_raci
  }
  this.area=[];
  this.authService.service("/api/get_area",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                        
      for(var i=0;i<res.length;i++){
        console.log(res[i]);
        var tx_area= "";
        if(res[i].id_ant==0){
          tx_area=res[i].area
        }else{
          if(res[i].role.toString()==""){
            tx_area=res[i].area;
          }else{
            tx_area=res[i].role;
          }
        }
        this.area.push({ 
          id:res[i].id,
          area:tx_area,
          idx:res[i].idx,
          id_ant:res[i].id_ant
        });        
      }
      this.ls_proceso();
      
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

public type_raci:String;
a_:0;
p_:0;
nvo_reg1(a,p){
  //this.type_raci="";
  this.a_=a;
  this.p_=p;
}
deliverables_;
kpi_;
tp_;
ttp_;
async dupl_raci2(itm){
  if(confirm("Confirm to copy this RACSI (+ data)?")==false)return;
  let postData = {
    id_raci:itm.id
  }
  this.procesos=[];
  //console.log(postData);
  await this.authService.service("/api/copy_raci2",postData)
  .then(
    async data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                      
      //this.update_raci();
      console.log(this.raci);
      console.log(this.raci_list);
      this.ls_raci()
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    }); 
}

bnd_htl=false;
bnd_list_ht=false;
msg_ht="";
bnd_htp=true;
bnd_ht=false;
ht_name="";
codigo_ht="";
fecha_ht="";
id_ht=0;
ht_usuario;
rev_ht=0;
tiempo_ht=0;
htd=[];
bndSavehtd=false;
bndSaveht=false;
id_imag_aux=0;
img_aux;
n_img_aux=0;
safeSrc;
link_p(itm){
  var id_raci_pdf=itm.raci2;  
  localStorage.setItem("t_raci","P");
  localStorage.setItem("id_raci_pdf",id_raci_pdf.toString());
  this.router.navigate([]).then(result => {  window.open('./#/fmt2', '_blank'); });     
}
org_id_=0;
chnimg(n,itm){
  this.id_imag_aux=itm.id;
  this.loading=true;
  var urphp="https://www.garocedev.com/api/index.php/api/archivos/"+itm.id+"/"+n;
  this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(urphp);
  this.loading=false;
  
  
 //this.router.navigate([]).then(result => {  window.open(urphp, '_blank'); });       
  return;

  this.id_imag_aux=itm.id;
  this.n_img_aux=n;
  switch (Number(n)) {
    case 1:
      this.img_aux=itm.img1
      break;
    case 2:
      this.img_aux=itm.img2
      break;
    case 3:
      this.img_aux=itm.img3
      break;
    case 4:
      this.img_aux=itm.img4
      break;
  
    default:
      break;
  }
}
edt_ht(itm){
  this.bndSaveht=false;
  //console.log(itm);
  this.id_ht=itm.id;
  this.ht_name=itm.nombre;
  this.fecha_ht=itm.fecha.substring(0,10);
  this.codigo_ht=itm.codigo;
}
del_ht(itm){
  if(confirm("Confirm to delete this record?")==false)return;
  let postData = {
    id:itm.id
  } 
  this.authService.service("/api/del_ht",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        //console.log(data)
        this.ls_ht(); 
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! exp', '', 'error');
      });
}
ls_ht_det(){
  this.htd=[];
  let postData = {
    id:this.id_ht
  } 
  console.log(postData);
  this.authService.service("/api/get_ht_det",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.tiempo_ht=0;
        for(var i=0 ;i<res.length;i++){
          var bnd_m=false;
          var bnd_im2=false;            
          var bnd_im3=false;
          var bnd_im4=false;
          if(res[i].img1!=null){bnd_im2=true;bnd_m=true}
          if(res[i].img2!=null){bnd_im3=true;bnd_m=true}
          if(res[i].img3!=null){bnd_im4=true;bnd_m=true}
          var tt=0;
          try {
            tt=Number(res[i].tiempo);  
          } catch (error) {              
          }
          this.tiempo_ht=this.tiempo_ht+tt;
          this.htd.push({n:i+1,
              id:res[i].id,
              simbolo1:res[i].simbolo1,
              simbolo2:res[i].simbolo2,
              simbolo3:res[i].simbolo3,
              simbolo4:res[i].simbolo4,
              principal:res[i].principal,
              importante:res[i].importante,
              razon:res[i].razon,
              tiempo:res[i].tiempo,
              img1:this.img(res[i].img1),
              img2:this.img(res[i].img2),
              img3:this.img(res[i].img3),
              img4:this.img(res[i].img4),
              bnd_im2:bnd_im2,
              bnd_im3:bnd_im3,
              bnd_im4:bnd_im4,
              bnd_m:bnd_m,
              url:res[i].url,
              role:res[i].role,
              rolecard:res[i].rolecard,
              val:res[i].valor

            });
        }
        //console.log(data)
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! exp', '', 'error');
      });
}
img(i){
  //.log(i)
   if(i===null){
     return "image-none.jpg"
   }
   return i;
 }
v_ht(itm){
  this.bnd_htl=true;
  this.bnd_ht=true;
  this.bnd_list_ht=false;
  this.id_ht=itm.id;
  this.ht_name=itm.nombre;
  this.fecha_ht=itm.fecha;
  this.codigo_ht=itm.codigo;
  this.rev_ht=itm.n;
  this.ht_usuario=itm.usuario_nombre;
  this.ls_ht_det();
}
ht_p(itm,p){
  this.msg_ht=itm.proceso;
  this.loading=true;
  this.p_=p;
  this.a_=0;
  this.loading=false;
  
  this.bnd_list_ht=true;
  this.bnd_htp=true;
  this.bnd_htl=false;
  this.ls_htp();
}
ht_list;

ht(itm,p,a){
  this.bnd_htp=false;
  this.msg_ht=itm.proceso;
  this.p_=p;
  this.a_=a;
  //console.log(p+"::"+a)
  this.loading=false
  
  this.cpa.nativeElement.click();
  this.ls_ht();
  this.bnd_list_ht=true;
  //this.router.navigate([]).then(result => {  window.open('./ht', '_blank'); });  
  
}
dep_id=0;
raciaux_=0;
nid_pro;
ls_ht(){
  let postData = {
    a_:this.a_,
    p_:this.p_
  } 
    console.log(postData);
    this.ht_list=[];
    this.authService.service("/api/get_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          var tot=res.length;
          console.log(res);
          if(tot==0){
            this.msg_ht="No result data";
          }
          for(var i=0;i<res.length;i++){
            this.ht_list.push({n:tot,
              id:res[i].id,
              usuario_nombre:res[i].usuario_nombre,
              nombre:res[i].nombre,
              codigo:res[i].codigo,
              fecha:res[i].fecha,
              tiempo:res[i].Tiempo
            });
            tot=tot-1;
          }
          //this.ht_list=data;
          //console.log(data)
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });   
}
ls_htp(){
  let postData = {
    p_:this.p_
  } 
    console.log(postData);
    this.ht_list=[];
    this.authService.service("/api/get_ht_p",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          var tot=res.length;
          console.log(res);
          if(tot==0){
            this.msg_ht="No result data";
          }
          for(var i=0;i<res.length;i++){
            this.ht_list.push({n:tot,
              id:res[i].id,
              usuario_nombre:res[i].usuario_nombre,
              nombre:res[i].nombre,
              codigo:res[i].codigo,
              fecha:res[i].fecha,
              tiempo:res[i].Tiempo
            });
            tot=tot-1;
          }
          //this.ht_list=data;
          //console.log(data)
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });   
}
t_memo="";
ap_memo="";
lado="";
memoria(){
  var aux=[];
  //console.log(this.t_memo);
  //console.log(this.ap_memo);
  switch (this.t_memo) {
    case "del":
      //////////////////////////////////////////////
        switch (this.ap_memo) {
          case "area":
            for(var i=0;i<this.area.length;i++){
              if(this.area[i].id!=this.id_dep){
                aux.push(this.area[i]);
              }
            }
            this.area=aux;   
            break;
          case "pro":            
            for(var i=0;i<this.procesos.length;i++){
              if(this.id_pro !=this.procesos[i].id){
                aux.push(this.procesos[i]);
              }  
            }
            this.procesos=aux;
          break;
        }
      break;
      //////////////////////////////////////////////
    case "ins":        
    //////////////////////////////////////////////
        switch (this.ap_memo) {
          case "area":
            var max_=0;
            for(var i=0;i<this.area.length;i++){
              if(max_ <this.area[i].idx){
                max_=this.area[i].idx;
              }
            }          
            if(this.org_id_>0)this.dep_=this.fn_nom_org(this.org_id_);
            this.area.push({id:this.dep_id, area:this.dep_,idx:max_,id_ant:this.org_id_});  
            break;          
          case "pro":
            var max_=0;
            for(var i=0;i<this.procesos.length;i++){
              if(max_ <this.procesos[i].idx){
                max_=this.procesos[i].idx;
              }
            }
            
            this.procesos.push({id:Number(this.id_pro),proceso:this.pro_,
              descripcion:this.des_=undefined?"":this.des_,
                idx:max_,valor:0,valor_:"",raci2:this.raciaux_})   
            break;
          }
    //////////////////////////////////////////////
    
      break;    
    case "ins_lado":
      switch (this.ap_memo) {
        case "pro":       
        //console.log("-inslado pro-");
        //console.log(this.lado);
          var aux=Array();            
          if(this.lado=="i"){
            for(var i=0;i<this.procesos.length;i++){                   
              if(this.id_pro==this.procesos[i].id){
                aux.push({id:Number(this.nid_pro),
                    proceso:this.pro_,
                    descripcion:this.des_=undefined?"":this.des_,
                    idx:0,
                    valor:0,valor_:"",raci2:this.raciaux_});      
                aux.push(this.procesos[i]);
              }else{
                aux.push(this.procesos[i]);                  
              }
            }
          }else if(this.lado=="d"){
            for(var i=0;i<this.procesos.length;i++){   
              if(this.id_pro==this.procesos[i].id){
                aux.push(this.procesos[i]);
                aux.push({id:Number(this.nid_pro),
                    proceso:this.pro_,
                    descripcion:this.des_=undefined?"":this.des_,
                    idx:0,
                    valor:0,valor_:""});                        
              }else{
                aux.push(this.procesos[i]);                  
              }
            }
          }
          this.procesos=aux;
          
        break;
        case "area":
          if(this.org_id_>0)this.dep_=this.fn_nom_org(this.org_id_);
          //this.area.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
          var aux=Array();            
          if(this.lado=="i"){
            for(var i=0;i<this.area.length;i++){                   
              if(this.id_dep==this.area[i].id){
                aux.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
                aux.push(this.area[i]);
              }else{
                aux.push(this.area[i]);                  
              }
            }
          }else if(this.lado=="d"){
            for(var i=0;i<this.area.length;i++){   
              if(this.id_dep==this.area[i].id){
                aux.push(this.area[i]);
                aux.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
              }else{
                aux.push(this.area[i]);                  
              }
            }
          }
          this.area=aux;
        break;          
      }
      break;
    case "upd":       
      switch (this.ap_memo) {
        case "area":
          /*
            dep:this.dep_,
            id:this.id_dep
          */
          for(var i=0;i<this.area.length;i++){
            if(this.id_dep==this.area[i].id){
              this.area[i].area=this.dep_;   
              if(this.area[i].id_ant>0)this.area[i].area=this.fn_nom_org(this.org_id_);
            }
          }
          break;
        case "pro":
          for(var i=0;i<this.procesos.length;i++){
            if(this.id_pro==this.procesos[i].id){
              this.procesos[i].descripcion=this.des_;
              this.procesos[i].proceso=this.pro_;    
              this.procesos[i].raci2=this.raciaux_;            
            }
          }
        break;
        case "pa":
          var bnd=0;
          for(var i=0;i<this.rel_pa.length;i++){
            if(this.rel_pa[i].id_a==this.a_ && this.rel_pa[i].id_p==this.p_ ){
              bnd=1;
             //console.log( this.rel_pa[i]);
             //console.log("existe");
              this.rel_pa[i].rol=this.type_raci.toString();
              this.rel_pa[i].tipo_time=this.ttp_;
              this.rel_pa[i].ttime=this.tp_;
              this.rel_pa[i].valor=this.val_.toString();

            }
          }
          if(bnd==0){
            //console.log("nuevo");
            this.rel_pa.push({id:0,
              id_p:this.p_,
              id_a:this.a_,
              rol:this.type_raci.toString(),
              c:"",
              entregable:"",
              impacto:"",
              ttime:this.tp_,
              tipo_time:this.ttp_,
              valor:this.val_});  
          }
          break;
      }
    //////////////////////////////////////////////
    //////////////////////////////////////////////
      break; 
    
    case "mov":       
      var aux_id=0;
      var aux_idx=0;
      var bnd_id=0;
      var aux_proceso;
      switch (this.ap_memo) {
        case "pro":            
          if(this.lado=="i"){
            for(var i=0;i<this.procesos.length;i++){   
              if(this.id_pro==this.procesos[i].id){
                try {                    
                  if(i!=0){
                    aux_proceso=this.procesos[i];
                    this.procesos[i]=this.procesos[i-1];
                    this.procesos[i-1]=aux_proceso;
                  }
                } catch (error) {                    
                }              
              }            
            }
           }else if(this.lado=='d'){
             var bndd=0;
              for(var i=0;i<this.procesos.length;i++){  
                if(this.id_pro==this.procesos[i].id){                                          
                  if(i<(this.procesos.length-1)){ 
                    aux_id=i;
                    aux_proceso=this.procesos[i];
                    bndd=1; 
                  }
                }            
              } 
              if(bndd==1){
                this.procesos[aux_id]=this.procesos[aux_id+1];
                this.procesos[aux_id+1]=aux_proceso; 
              }
           }
          break;
        case "area":            
            if(this.lado=="i"){
              for(var i=0;i<this.area.length;i++){   
                //console.log(i);
                if(this.id_dep==this.area[i].id){   
                  try {
                    if(i!=0){
                      aux_proceso=this.area[i];                    
                      this.area[i]=this.area[i-1];
                      this.area[i-1]=aux_proceso; 
                    }
                  } catch (error) {                     
                  }                    
                }
              }    
             }else if(this.lado=='d'){
              var bndd=0
              for(var i=0;i<this.area.length;i++){   
                //console.log(i);
                //console.log(this.id_dep);
                //console.log(this.area[i])
                //console.log(this.area)
                if(this.id_dep==this.area[i].id){
                  aux_id=i;
                  aux_proceso=this.area[i];
                  bndd=1;   
                }            
              } 
              if(bndd==1){
                this.area[aux_id]=this.area[aux_id+1];
                this.area[aux_id+1]=aux_proceso; 
              }
              //console.log(this.area)                
             }             
            break;        
      }
    //////////////////////////////////////////////
    //////////////////////////////////////////////
      break;    
    default:        
      break;
  }
  
}
fn_nom_org(id_){
  console.log(id_);
  //console.log(this.org_);
  for(var i=0;i<this.org_.length;i++){
    if(this.org_[i].id_role==id_){
      return this.org_[i].role_card;
    }
  }
  return "";
}
gdasa(){
  let postData = {
    a_:this.a_,
    p_:this.p_,
    rol:this.type_raci,
    deliver:this.deliverables_,
    kpi_:this.kpi_,
    tp:this.tp_,
    ttp:this.ttp_,
    valor:this.val_
  }
  this.t_memo="upd";
  this.ap_memo="pa";
  //console.log(postData);
  this.authService.service("/api/ins_pa2",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                        
      //this.update_raci();
      this.memoria();
      this.cpa.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  

}
id_cliente:Number=0;
dep_:any;
pro_:any;
catalog_raci(){
  if(confirm("Confirm to create catalog from role card?")==false)return;
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,  
  }
  //console.log(postData);
  this.authService.service("/api/ins_catalog_raci",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      this.update_raci();   
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });   
}
del_raci(itm){
  if(confirm("Confirm to delete this record?")==false)return;
  let postData = {
    id:itm.id
  }
  //console.log(postData);
  this.authService.service("/api/del_raci",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      
      this.ls_raci();
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });   
}
gda_dep_lado(l){
  if (this.dep_==undefined || this.dep_.length==0)return ;
  let postData = {
    id:this.id_dep,
    dep:this.dep_,
    lado:l
  }
  console.log(postData);
  this.authService.service("/api/ins_dep_lado",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      this.update_raci();                     
      
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

gda_dep(){
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,
    dep:this.dep_
  }
  console.log(postData);
  this.authService.service("/api/ins_dep",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      this.update_raci();                     
      
      this.cdep.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
des_:any;
val_:any;
gda_pro_lado(l){
  if(this.pro_==undefined || this.pro_=="")return;
  this.pro_=this.clean_chars(this.pro_);
  this.des_=this.clean_chars(this.des_);
  let postData = {
    id:this.id_pro,
    lado:l,
    pro:this.pro_,
    des:this.des_,
    valor:"",
    raci:this.raciaux_
  }
  this.t_memo="ins_lado";
  this.ap_memo="pro";
  this.lado=l;
  console.log(postData);
  this.authService.service("/api/ins_pro_lado2",postData)
  .then(
    data => {
      
      
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);        
      //console.log(res);
      if(res[0][0].repetido==0){
        this.nid_pro=res[0][0].id;  
        this.memoria();
        //console.log(this.nid_pro);
        //console.log("se inserta");
      }else{
        //console.log(data);
        //console.log("repetido")
      }
      
      
      //this.update_raci();  
      this.cprol.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
clean_chars(c){

  if(c!=undefined){
    c=c.replace(/[']/g, "`");
  }else{
    return "";
  }
  return c;
}
gda_pro(){
  if(this.pro_==undefined || this.pro_=="")return;
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,
    pro:this.pro_,
    des:this.des_=undefined?"":this.des_,
    valor:"",
    raci:this.raciaux_
  }
  console.log(postData);
  this.pro_=this.clean_chars(this.pro_);
  this.des_=this.clean_chars(this.des_);
  this.t_memo="ins";
  this.ap_memo="pro";
  this.authService.service("/api/ins_pro",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      this.id_pro=res.insertId;
      this.memoria()
      //this.update_raci();  
      this.cpro.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

nvo_reg(r,d,k,t,tt,v){ 
  //console.log("nvo"); 
  this.type_raci=r;  
  this.val_=v;
  //console.log(d);
  //console.log(k);
  //console.log(t);
  //console.log(tt);
  this.deliverables_=d;
  this.kpi_=k;
  this.tp_=t;
  this.ttp_=tt;
}

get_value(i,j){
    for(let p=0;p<this.procesos.length;p++){
      for(let a=0;a<this.area.length;a++){ 
        //console.log(""+this.procesos[p].id+" " + this.area[a].id);
        var bnd=0;  
        var r_:any=[];
        for(let p_a=0;p_a<this.rel_pa.length;p_a++){
          if(this.rel_pa[p_a].id_a==this.area[a].id &&
             this.rel_pa[p_a].id_p==this.procesos[p].id){
              bnd=1;
              r_=this.rel_pa[p_a];
              //console.log(this.rel_pa[p_a].rol);
          }
          
        }
        if(bnd==1){
          if(p==i&&a==j){
            return r_;
          }
          
        }

      }

    }
    //console.log("nada");
    var aux= {id:0,id_p:i,id_a:j,rol:"",c:""};
    //this.rel_pa.push(aux);
    return aux;
  }
   j_ant:number=0;
   load_rasci(){
    //console.log("raci");
    var matrix = new Array();
    var matrix_c = new Array();
    var rows = this.procesos.length;
    var cols = this.area.length;
    //console.log(rows);
    //console.log(cols);
    for (var j = 0; j < cols; j++)
      matrix_c[j] = "";
    for (var i = 0; i < rows; i++)
      matrix[i] = new Array(matrix_c);
      for (var i = 0; i < rows; i++){
        for (var j = 0; j < cols; j++){
          matrix[i][j]=this.get_value(i,j);   
          
            //console.log(j);
        }
      }
    //console.log(matrix);
     
      for (var i = 0; i < rows; i++)
      for (var j = 0; j < cols; j++){
        //console.log(""+i+" " + j);
        if (i==(rows-1) && (matrix[i][j].rol=='R' || matrix[i][j].rol=='AR')   ){
          
            matrix[i][j].c="CR"
          
        } 
        if (i==0 && (matrix[i][j].rol=='R' || matrix[i][j].rol=='AR')){
          this.j_ant=j;
          //console.log("R" + this.j_ant);
        }else{
          if((matrix[i][j].rol=='R' || matrix[i][j].rol=='AR') ){

            //console.log("R"+this.j_ant);
            if(this.j_ant==j){

              matrix[i-1][j].c="CR";
            }else if(this.j_ant<j){
              if((this.j_ant-j)==1){
                //console.log("es igual");
              }else{
                  for(var x=this.j_ant;x<=j;x++){
                    if(matrix[i-1][x].id!=0){
                      matrix[i-1][x].c="CL";
                    }else{
                      //console.log("aqui 1");  
                      //console.log(j);  
                      //console.log(this.j_ant); 
                      if (x==j)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C4",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                      else if((j-this.j_ant)==1)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C4",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                      else
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"CL",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                      //-----------------------
                    }
                  }
                  matrix[i-1][j].c="C4";
              }
              matrix[i-1][this.j_ant].c="CR2";
            }else{
              //console.log(j);
              //console.log(this.j_ant);
              if((j-this.j_ant)==1){
                //console.log("es igual");
              }else{
                for(var x=j;x<this.j_ant;x++){
                  if(matrix[i-1][x].id!=0){
                    matrix[i-1][x].c="CL";
                  }else{
                    //console.log("aqui 2");  
                    if (x==j)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C1",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                    else if((this.j_ant-j)==1)
                    this.rel_pa.push({id:0,id_p:(i),id_a:x+1,rol:"&nbsp;",c:"C1",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                    else
                    this.rel_pa.push({id:0,id_p:(i),id_a:x+1,rol:"&nbsp;",c:"CL",entregable:"",impacto:"",ttime:0,tipo_time:"",valor:""});
                    //-----------------------
                  } 
                  //console.log(x);
                }
                matrix[i-1][j].c="C1";
              }
              matrix[i-1][this.j_ant].c="CR1";
            }  
            this.j_ant=j;
          }
        }
          
      }
    
     //console.log(matrix);
     //console.log(this.rel_pa);
  }
  

}

